
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29 17.9968C31.2091 17.9968 32 16.2062 32 13.9975C32 11.7888 31.2091 9.99824 29 9.99824V17.9968Z","fill":"#0093FF"}}),_c('path',{attrs:{"d":"M15.0942 20.0051C15.6499 20.0051 16.1005 19.5537 16.1005 18.9969V8.99843C16.1005 8.44162 15.6499 7.99023 15.0942 7.99023H5.48403C3.81807 7.99023 2.24244 8.79625 1.20172 10.1809C-0.400574 12.3126 -0.400574 15.6827 1.20172 17.8145C2.24244 19.1991 3.81807 20.0051 5.48403 20.0051H6.63568C7.00522 20.0051 7.34503 20.208 7.52081 20.5337L13.4191 31.8708C13.7828 32.5677 14.473 33 15.222 33C16.7145 33 17.7129 31.3649 17.1067 29.9132L13.3808 21.4367C13.0722 20.7686 13.5592 20.0051 14.294 20.0051H15.0942Z","fill":"#0093FF"}}),_c('path',{attrs:{"d":"M29 25.5446V2.49976C29 1.67122 28.0579 1.19638 27.3939 1.69027L17.9064 8.18912C17.6507 8.37932 17.5 8.67955 17.5 8.99862V18.9968C17.5 19.3158 17.6507 19.6161 17.9064 19.8063L27.3939 26.354C28.0579 26.8479 29 26.3731 29 25.5446Z","stroke":"black","stroke-width":"1.04292"}})])
          )
        }
      }
    